import Landing from './landing'
import FavouritePlayer from './favouritePlayer'
import FavouriteKit from './favouriteKit'
import ShirtNumber from './shirtNumber'
import Overview from './overview'
import ProfileBuilder from './profileBuilder'
import VerifyPassword from './verifyPassword'

export default ProfileBuilder
export { Landing, FavouritePlayer, FavouriteKit, ShirtNumber, Overview, VerifyPassword }
